import { type ComponentPropsWithRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FilePreviewIconProps = Omit<ComponentPropsWithRef<'div'>, 'type'>;

export const FilePreviewIcon = memo(({ className, ...restOfProps }: FilePreviewIconProps) => {
  return (
    <div
      className={cn('flex size-8 items-center justify-center rounded-4 bg-teal-3 text-teal-11', className)}
      {...restOfProps}
    />
  );
});

FilePreviewIcon.displayName = 'FilePreviewIcon';
